module.exports = __webpack_public_path__ + "static/img/001.6b45da1c.png";